import React from 'react';
import { TradingViewChart } from './components/TradingViewChart';
export function App() {
  return <div className="flex h-screen w-full flex-col bg-white" data-id="element-0" data-mp="35d3iux99qekc">
      <header className="flex h-[46px] shrink-0 items-center border-b border-neutral-200 bg-white px-4 sm:px-5" data-id="element-1" data-mp="35eocmknrdth5">
        <h1 className="text-[15px] font-semibold tracking-tight text-black" data-id="element-2" data-mp="3fahwyq7pyr9h">
          INDICADORES VIP
        </h1>
      </header>
      <main className="min-h-0 flex-1 bg-white" data-id="element-3" data-mp="2rlyreig20sl3">
        <TradingViewChart data-id="element-4" data-mp="2riko97zkgfcl" />
      </main>
    </div>;
}